import { getEligibilityLite } from "../../authentication/AuthenticationService";
import { type RedirectData } from "../types";

const PARTICIPANT_URL = "participant/home/#/dashboard/retirement-income";
const DASHBOARD_URL = "dashboard/#/home";
const ACCOUNTS_OVERVIEW_URL = "participant/accounts/#/overview";
const LEGACY_NPDI_URL = "legacyNpdiBegin.do?accu=GwrsWR";

const getExternalRedirectUrl = async (data: RedirectData, featureName?: string, gaId?: string) => {
    try {
        if (data.destinationUrl === "d") {
            let url = `participant/${window.location.search}#/d`;
            if (featureName) {
                url += `/${featureName}`;
            }
            if (gaId) {
                url += `/${gaId}`;
            }
            return url;
        } else if (String(data.destinationUrl).toLowerCase() === "liatlanding") {
            const { homePageEligibility } = await getEligibilityLite();
            if (homePageEligibility) {
                return PARTICIPANT_URL;
            }
            return ACCOUNTS_OVERVIEW_URL;
        } else if (String(data.destinationUrl).toLowerCase() === "dashboardlanding2") {
            sessionStorage.setItem("affiliateAuth", "true");
            return DASHBOARD_URL;
        } else if (data.destinationUrl === "NPDI_LEGACY_REDIRECT") {
            return __iframeUrl__ ? `${__iframeUrl__}/${LEGACY_NPDI_URL}` : LEGACY_NPDI_URL;
        }
        return data.destinationUrl;
    } catch (error) {
        console.error("Error getting external redirect URL", error);
        throw error;
    }
};

export default getExternalRedirectUrl;
